import React, { Component } from "react";
import Classnames from "classnames";
import { observer } from "mobx-react";
import Store from "@/stores";

@observer
class Option extends Component {
	state = { toggle: false }
	render() {
		const { option, optionIndex, getRanking } = Store._ladderStore;
		const { job, mode, season, server } = option;
		const { ci, ji, mi, si } = optionIndex;
		const { toggle } = this.state;
		const seasonTotal = season.filter(v => v.type === "现赛季" || v.type === "现非赛季").map(v => (
			<span
				key={v.code}
				className={v.code === ci ? "active" : ""}
				onClick={() => getRanking(0, { ci: v.code })}
			>
				{v.type}
			</span>
		));
		const seasonYes = [];
		const seasonNo = [];
		season.filter(v => v.code && v.type !== "现赛季" && v.type !== "现非赛季").forEach(v => v.type.includes("非") ? seasonNo.push(v) : seasonYes.push(v));
		const seasonList1 = seasonYes.map(v => (
			<span
				key={v.code}
				className={v.code === ci ? "active" : ""}
				onClick={() => getRanking(0, { ci: v.code })}
			>
				{v.type}
			</span>
		));
		const seasonList2 = seasonNo.map(v => (
			<span
				key={v.code}
				className={v.code === ci ? "active" : ""}
				onClick={() => getRanking(0, { ci: v.code })}
			>
				{v.type}
			</span>
		));
		const seasonList = ci % 10 === 0 ? seasonList2 : seasonList1;
		const jobList = job.map(v => (
			<span
				key={v.code}
				className={v.code === ji ? "active" : ""}
				onClick={() => getRanking(0, { ji: v.code })}
			>
				{v.type}
			</span>
		));
		const modeList = mode.map(v => (
			<span
				key={v.code}
				className={v.code === mi ? "active" : ""}
				onClick={() => getRanking(0, { mi: v.code })}
			>
				{v.type}
			</span>
		));
		const serverList = server.map(v => (
			<span
				key={v.code}
				className={v.code === si ? "active" : ""}
				onClick={() => getRanking(0, { si: v.code })}
			>
				{v.type}
			</span>
		));
		return (
			<ul className="ladder-option">
				<li><b>服务器：</b>{serverList}</li>
				<li><b>赛季：</b>{seasonTotal}<em className={toggle ? "show" : ""} onClick={this.toggleList.bind(this)}>更多</em></li>
				<li className={Classnames("list", { show: toggle })}>{seasonList}</li>
				<li><b>职业：</b>{jobList}</li>
				<li><b>模式：</b>{modeList}</li>
			</ul>
		);
	}
	toggleList() {
		this.setState(prevState => ({ toggle: !prevState.toggle }));
	}
}
export default Option;